import { LinkRoute } from '@/components/common/Link'
import { Icon } from '@/components/icons/Icon'
import { type QuickLinkType } from '@/defs/nav'
import { useRandomLink } from '@/hooks/useRandomLink'
import { trackEvent } from '@/utils/analyticsUtil'

import styles from '../MenuNavQuickLinks.module.scss'

type Props = {
  item: Extract<QuickLinkType, { href: string }>
}

export const MenuNavQuickLinksRandom = ({ item: { href, icon, label, superscript } }: Props) => {
  const { loading, onClick } = useRandomLink()

  return (
    <LinkRoute
      aria-busy={loading || undefined}
      className={styles.link}
      href={href}
      onClick={(e) => {
        trackEvent({ action: 'nav_click', category: 'menu_quick_link', label: href })
        onClick(e)
      }}
    >
      <span className={styles.icon}>
        <Icon name={loading ? 'spinner' : icon} />
      </span>
      <span className={styles.label}>
        {label}
        {superscript && <sup>{superscript}</sup>}
      </span>
    </LinkRoute>
  )
}
